import InProcessApplicationsContainer from "../../../Components/Applications/InProcessApplications";
import { useEffect } from "react";
import RoleGuard from "../../RoleGuard";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

const InProcessApplication = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "In Process Applications";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "hr-officer", "recruiter"]}
      />

      {/* Main content */}
      <InProcessApplicationsContainer/>
    </>
  );
};

export default InProcessApplication;
